import React, { useRef } from 'react';
import { PageInfo } from '@css-xp/graphtypes';
import { AvailableAppForProduct } from '../types';

type AvailableAppsForProduct = {
  edges?: AvailableAppForProduct[];
  nodes?: AvailableAppForProduct[];
  pageInfo: PageInfo;
  totalCount?: number;
};

type PartnerProductAppSearchListProps = {
  productAppList: AvailableAppsForProduct;
  fieldProps?: any;
  onClick?: (id: string) => void;
  onClose?: (closeDropdown: boolean) => void;
  setCursor?: (cursor: string) => void;
};

export const PartnerProductAppSearchList = ({
  productAppList,
  fieldProps,
  onClick,
  onClose,
  setCursor,
}: PartnerProductAppSearchListProps) => {
  const myCustomDropDown = useRef<any>();
  const onMouseClick = React.useCallback(
    (event: MouseEvent) => {
      if (myCustomDropDown?.current && !myCustomDropDown?.current?.contains(event?.target)) {
        onClose?.(true);
      }
    },
    [productAppList?.nodes?.length]
  );

  React.useEffect(() => {
    window.addEventListener('mousedown', onMouseClick);

    return () => {
      window.removeEventListener('mousedown', onMouseClick);
    };
  }, [onMouseClick]);

  return (
    <div className="product-app-holder" ref={myCustomDropDown}>
      {productAppList?.nodes?.length === 0 && <h4 className="product-app-nodata">No apps found</h4>}
      {productAppList?.nodes?.map((details: AvailableAppForProduct) => {
        return (
          <>
            <div
              className="product-app-item"
              data-testId={`product-app-item-${details?.id}`}
              onClick={() => {
                const appObj = {
                  label: details?.name,
                  value: details?.id,
                };
                fieldProps && fieldProps.onChange(appObj);
                onClick && onClick(details?.id);
                onClose && onClose(true);
              }}
            >
              {details?.name}
            </div>
          </>
        );
      })}
      {productAppList && productAppList?.pageInfo?.hasNextPage && (
        <div className="product-app-item">
          <h4 data-testId={'apps-load-more'} onClick={() => setCursor?.(productAppList?.pageInfo?.endCursor ?? '')}>
            Load more
          </h4>
        </div>
      )}
    </div>
  );
};
